<template>
  <v-card>
    <v-card-title>Rekapan Jurnal Bulanan</v-card-title>
    <v-card-text>
      <form
        @submit.prevent="
          () => {
            options.page = filter.page = 1;
            get();
          }
        "
      >
        <v-row>
          <v-col cols="12" lg="6">
            <v-btn
              role="a"
              target="_blank"
              :href="pdf_url"
              text
              color="red"
              dark
            >
              Export PDF
            </v-btn>
          </v-col>

          <!-- <v-col cols="12" lg="3">
            <v-autocomplete
              :items="data.guru"
              v-model="filter.guru_id"
              @change="
                options.page = filter.page = 1;
                get();
              "
              clearable
              label="Pilih Guru"
              :disabled="$root.app.xlevel == 'user' ? true : false"
            ></v-autocomplete>
          </v-col> -->

          <v-col cols="6" lg="3">
            <v-select
              v-model="filter.bulan"
              @input="
                () => {
                  options.page = filter.page = 1;
                  get();
                }
              "
              label="Bulan"
              placeholder="Pilih Bulan"
              :rules="[(v) => !!v || 'bulan harus dipilih']"
              :items="data.bulan"
            ></v-select>
          </v-col>
          <v-col cols="6" lg="3">
            <v-text-field
              type="number"
              v-model="filter.tahun"
              @change="
                () => {
                  options.page = filter.page = 1;
                  get();
                }
              "
              label="Tahun"
              placeholder="Pilih Tahun"
              :rules="[(v) => !!v || 'tahun harus dipilih']"
            ></v-text-field>
          </v-col>
        </v-row>
        <button type="submit"></button>
      </form>
      <v-data-table
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 50, 100],
        }"
        disable-sort
        :headers="[
          {
            text: 'Hari, Tanggal',
            value: 'tanggal',
          },
          {
            text: 'Guru',
            value: 'guru.nama',
          },
          {
            text: 'Mata Pelajaran',
            value: 'mata_pelajaran.nama',
          },
          {
            text: 'Pokok Bahasan',
            value: 'pokok_bahasan',
          },
          {
            text: 'Rombel / Ruang / Jam Ke',
            value: 'jadwal',
          },
          {
            text: 'Jml Siswa Hadir',
            value: 'siswa_hadir',
          },
          {
            text: 'Dokumentasi',
            value: 'dokumentasi',
          },
        ]"
        :items="datas"
        :loading="is.loading"
        loading-text="Loading... Please wait"
        :server-items-length="recordsTotal"
        :options.sync="options"
      >
        <template slot="item.jadwal" slot-scope="{ item }">
          {{ item.rombel ? item.rombel.rombel : "-" }}
          /
          {{ item.ruang || "-" }}
          /
          {{ item.jam_kbm_full }}
        </template>

        <template slot="item.siswa_hadir" slot-scope="{ item }">
          {{ item.siswa_hadir }}/{{ item.total_siswa }}
        </template>

        <template slot="item.dokumentasi" slot-scope="{ item }">
          <v-btn
            v-if="item.dokumentasi"
            small
            text
            color="blue"
            role="a"
            :href="item.dokumentasi_url"
            target="_blank"
            >Lihat</v-btn
          >
        </template>

        <template slot="item.tanggal" slot-scope="{ item }">
          {{ item.hari.toUpperCase() }},
          {{ item.tanggal }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      datas: [],
      modal: {
        delete: false,
        anulir: false,
      },
      req: {},
      is: {
        loading: true,
      },
      filter: {
        limit: 10,
        search: "",
        page: 1,
      },
      options: {},
      recordsTotal: 0,
      pdf_url: "",
      data: {
        bulan: [
          {
            value: 1,
            text: "Januari",
          },
          {
            value: 2,
            text: "Februari",
          },
          {
            value: 3,
            text: "Maret",
          },
          {
            value: 4,
            text: "April",
          },
          {
            value: 5,
            text: "Mei",
          },
          {
            value: 6,
            text: "Juni",
          },
          {
            value: 7,
            text: "Juli",
          },
          {
            value: 8,
            text: "Agustus",
          },
          {
            value: 9,
            text: "September",
          },
          {
            value: 10,
            text: "Oktober",
          },
          {
            value: 11,
            text: "November",
          },
          {
            value: 12,
            text: "Desember",
          },
        ],
        guru: [],
      },
    };
  },
  watch: {
    options(val) {
      this.filter.limit = val.itemsPerPage;
      this.filter.page = val.page;
      this.get();
    },
  },
  created() {
    this.filter.guru_id = parseInt(this.$root.app.xid);

    this.getBulanIni();
    this.get();
    this.getData();
  },
  methods: {
    getBulanIni() {
      const date = new Date();
      var bulan = date.getMonth() + 1;

      this.filter.tahun = date.getFullYear();
      this.filter.bulan = bulan;
    },
    get() {
      this.req = {};
      this.is.loading = true;
      this.filter.status = "1";

      if (this.filter.guru_id == null) {
        this.filter.guru_id = "";
      }

      this.$root.app.http
        .get("/api/matapelajaran/jurnalmengajar", this.filter)
        .then((res) => {
          this.pdf_url = res.pdf_url;
          this.datas = res.data;
          this.recordsTotal = res.recordsTotal;
          this.is.loading = false;
        });
    },
    getData() {
      this.data.guru = [
        {
          value: "",
          text: "Semua Guru",
        },
      ];
      this.$root.app.http.get("/api/guru").then((res) => {
        res.data.forEach((item) => {
          this.data.guru.push({
            value: item.id,
            text: item.nama,
          });
        });
      });
    },
  },
};
</script>
